import { AxiosError } from 'axios';
import { apiRequest, setAPIRequestHeaders } from '../../apiCall'
import { loginType, registerDomainType, registerType, registerUserInfoType } from '../../types/authTypes/loginTypes';

class AuthService {


    /**
    * Post Login
    * @returns
    */
    async postLogin(params: loginType): Promise<any> {
        try {
            const response = await apiRequest("Auth.Login", params, "");
            return response.data
        } catch (error: any) {
            throw error
        }


    }

    /**
 * Post Login Tenant
 * @returns
 */
    async postLoginTenant(tenantId: string): Promise<any> {
        try {
            const response = await apiRequest("Auth.LoginUserInTenant", { tenantId }, "");
            return response.data
        } catch (error: any) {
            throw error
        }


    }


    async postRegistration(params: registerUserInfoType): Promise<any> {
        try {
            const response = await apiRequest("Auth.Registration", { ...params }, "");
            return response
        } catch (error: any) {
            return error
        }


    }


    async getTenantMemberRegistrationStateService(params: { id: string, token: string }): Promise<any> {
        try {

            setAPIRequestHeaders(`Bearer ${params.token}`)
            const response = await apiRequest("TeamMember.GetTenantMemberRegistrationState", {}, "?tenantMemberId=" + params.id);
            return response
        } catch (error: any) {
            throw error
        }


    }

    async setTenantMemberUserPasswordService(params: any): Promise<any> {
        try {
            setAPIRequestHeaders(`Bearer ${params.token}`)
            const response = await apiRequest("TeamMember.SetTenantMemberUserPassword", { ...params }, "");
            return response
        } catch (error: any) {
            throw error
        }


    }

    async postDomainRegistrationService(params: registerDomainType): Promise<any> {
        try {
            const response = await apiRequest("Auth.DomainRegistration", { ...params }, "");
            return response
        } catch (error: any) {
            throw error
        }


    }

    async sendResetPasswordEmailService(email: string): Promise<SendResetPasswordEmailResponseType> {
        try {
            const response = await apiRequest("Auth.SendResetPasswordEmail", { email }, "");
            return response.data
        } catch (error: any) {
            throw error
        }


    }


    async resetPasswordService(params: ResetPasswordResponsePayload): Promise<ResetPasswordResponseType> {
        try {
            const response = await apiRequest("Auth.ResetPassword", { ...params }, "");
            return response.data
        } catch (error: any) {
            throw error
        }


    }

}

export default new AuthService();

export type errorResponse = {
    response: responseType
}

type dataResponse = {
    title: string
}

type responseType = {
    data: dataResponse
}


export type SendResetPasswordEmailResponseType = {
    errors: [
        {
            errorKey: string,
            errorMessage: string
        }
    ],
    confirms: [
        {
            confirmKey: string,
            confirmMessage: string,
            result: any
        }
    ],
    value: true
}

export type ResetPasswordResponseType = {
    successfullyChange: boolean,
    successUrl: string,
    failUrl: number
}

export type ResetPasswordResponsePayload = {
    password: string,
    email: string,
    token: string
}